import { FunctionComponent } from 'react';
import { TextField } from '../form/fields/text/TextInput';

interface MarginFieldProps {
  id: string;
  className?: string;
}

const MarginField: FunctionComponent<MarginFieldProps> = ({ id, className }) => {
  return (
    <TextField
      onlyDigits
      allowNegatives={true}
      maxDigitLength={8}
      className={className}
      id={id}
      label="Margin"
      placeholder="0"
      suffix="%"
    />
  );
};

export default MarginField;
